import { frontendURL } from '../../../helper/URLHelper';

const InstagramAutomationIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/instagram-automation'),
      name: 'instagram_automation_index',
      component: InstagramAutomationIndex,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
